import { render, staticRenderFns } from "./BillingGroupList.vue?vue&type=template&id=6444306c&scoped=true"
import script from "./BillingGroupList.vue?vue&type=script&lang=js"
export * from "./BillingGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6444306c",
  null
  
)

export default component.exports